import React from 'react';

const SocialFaceBookIcon = function SocialFaceBookIcon() {
  return (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="xiQ-Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-28" fillRule="nonzero">
          <circle id="Ellipse_76-Copy" fill="#3C5B9B" cx="18" cy="18" r="18" />
          <g id="facebook-f" transform="translate(12.000000, 7.000000)" fill="#FFFFFF">
            <path d="M11.2136241,12.9375 L11.8358982,8.77503906 L7.94515353,8.77503906 L7.94515353,6.07388672 C7.94515353,4.93511719 8.48865874,3.82509766 10.2312012,3.82509766 L12,3.82509766 L12,0.281210937 C12,0.281210937 10.3948654,0 8.86018525,0 C5.65604259,0 3.56166582,1.99363281 3.56166582,5.60265625 L3.56166582,8.77503906 L0,8.77503906 L0,12.9375 L3.56166582,12.9375 L3.56166582,23 L7.94515353,23 L7.94515353,12.9375 L11.2136241,12.9375 Z" id="Path" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SocialFaceBookIcon;
